module.exports = __webpack_public_path__ + "img/simplymotion-instagram.8ae2d478.png";